<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-15 11:52:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-05 17:07:55
 * @FilePath: /chaoyongtuan/src/components/business/addCommanderDrawer/addCommanderDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog
		custom-class="dialog-content"
		:append-to-body="true"
		title="添加团长"
		:visible.sync="dialogVisible"
		width="550px"
		:before-close="handleClose"
	>
		<el-form ref="form" :model="form" label-width="110px" :rules="rules" class="form-content" label-position="left">
			<el-form-item label="团长名称" prop="institution_name">
				<el-input class="input-style" placeholder="请输入团长名称" v-model="form.institution_name"></el-input>
			</el-form-item>
			<el-form-item label="团长主页链接" prop="main_url" v-if="$isDy(platformId)">
				<el-input placeholder="请输入团长主页链接" type="textarea" :row="9" class="input-style text-area" v-model="form.main_url"></el-input>
				<span class="fz-14 primary-color cursor-pointer link-jump" @click="goToUrl(0)">如何获取团长链接？</span>
			</el-form-item>
			<el-form-item label="团长活动ID" prop="outerActivityId" v-if="$isKs(platformId)">
				<el-input placeholder="请输入团长活动ID" type="textarea" :row="9" class="input-style text-area" v-model="form.outerActivityId"></el-input>
				<span class="link-jump fz-14 primary-color cursor-pointer" @click="goToUrl(1)">如何获取团长活动id？ </span>
			</el-form-item>
			<el-form-item label="跟进人" prop="userIds">
				<el-select class="select-follow" :popper-append-to-body="false" v-model="form.userIds" clearable placeholder="请选择跟进人" :multiple="true">
					<el-option v-for="item in partner_list" :key="item.userId" :label="item.name" :value="item.userId">
						<div class="select-li">
							<div class="select-list-li flex flex-align-center">
								<span class="mr-8">{{ item.name }}</span>
								<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
								<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
							</div>
						</div>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="备注">
				<el-input placeholder="请输入备注" type="textarea" class="input-style text-area" v-model="form.remark"></el-input>
			</el-form-item>
		</el-form>
		<div class="botton-content flex flex-just-end pr-24 pb-24">
			<el-button type="primary" @click="submit" :loading="btnLoading">确认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { drRoleType } from '@/utils/dataMap';
import throttle from 'lodash/debounce';
import { commonList } from '@/api/cooperationProgress';
import { addInstitution, institutionCreate } from '@/api/secondColonelManage';
export default {
	data() {
		return {
			dialogVisible: false,
			rules: {
				institution_name: [{ required: true, message: '请输入团长名称', trigger: 'blur' }],
				main_url: [{ required: true, message: '请输入团长主页链接', trigger: 'blur' }],
				userIds: [{ required: true, message: '请输入跟进人', trigger: 'blur' }],
				remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
				outerActivityId: [{ required: true, message: '请输入活动D', trigger: 'blur' }],
			},
			form: {
				institution_name: '',
				main_url: '',
				userIds: '',
				remark: '',
				outerActivityId: '',
			},
			btnLoading: false,
			partner_list: [],
			platformId: '',
		};
	},
	methods: {
		show(platformId) {
			this.dialogVisible = true;
			this.platformId = platformId;
			this.partnerList();
		},
		handleClose() {
			this.dialogVisible = false;
			this.form = {
				institution_name: '',
				main_url: '',
				userIds: '',
				remark: '',
				institutionName: '',
			};
		},
		async partnerList() {
			const { code, data = [] } = await commonList({ role_id: drRoleType.id, all_status: 1 });
			if (code !== 0) return;
			this.partner_list = data;
			if (!this.$auth.hasPermi('system:cooperativeColonel:switch')) {
				let name = this.vuex_userInfo.partner_role_name;
				let userIds = [];
				this.partner_list.forEach(item => {
					if (item.name === name) {
						userIds.push(item.userId);
					}
				});
				this.form.userIds = userIds[0];
			}
		},
		goToUrl(type) {
			const linkUrl = new Map([
				[0, 'https://chaoyongtuan.yuque.com/books/share/62382192-9a6a-412f-bf5e-2d2fbba5b03e/ugvyhr'],
				[1, 'https://sviptrader.yuque.com/uf27wf/lnzdk8/srzxzk?'],
			]);
			window.open(linkUrl.get(type));
		},
		submit: throttle(function () {
			this.$refs.form.validate(async valid => {
				if (!valid) return;
				const { form, platformId: platform_id } = this;
				let apiMaps = new Map([
					[1, addInstitution],
					[2, institutionCreate],
				]);
				let params = {
					...form,
					userIds: Array.isArray(form.userIds) ? form.userIds : [form.userIds],
					platform_id,
				};
				// 视频号 暂时可以这样写  视频号没有团长不会走到这里
				if (this.$isDy(platform_id)) {
					delete params.institutionName;
					delete params.outerActivityId;
					params.order_anchor_num = 0;
					params.recommend_type = '';
					params.order_product_num = 0;
					params.sale_amount = 0;
				}
				if (this.$isKs(platform_id)) {
					delete params.main_url;
					params.institutionName = form.institution_name;
					delete params.institution_name;
				}
				const { code } = await apiMaps.get(+platform_id)(params);
				if (code !== 0) return;
				this.$message.success('添加成功');
				this.$emit('refresh');
				this.handleClose();
			});
		}, 1000),
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding: 15px 24px 15px 24px !important;
}
/deep/ .el-dialog__title {
	font-weight: 500 !important;
	font-size: 16px !important;
	color: @color-text-primary !important;
}
/deep/ .el-dialog__body {
	padding: 0px !important;
}
.form-content {
	padding: 24px 24px 48px 24px;
	.input-style {
		/deep/ .el-input__inner {
			width: 100%;
		}
	}
}
.text-area {
	/deep/ .el-textarea__inner {
		border-radius: 4px !important;
	}
}
.select-follow {
	/deep/ .el-select-dropdown {
		border-color: @color-gy3;
	}
	/deep/ .select-li {
		border-bottom: 1px solid @color-gy3;
	}
	/deep/ .el-select-dropdown__item {
		padding: 0px !important;
		height: 100% !important;
		line-height: 19px !important;
	}
	/deep/ .el-scrollbar__wrap {
		max-height: 306px;
	}
	.select-list-li {
		padding: 6px 12px 6px 12px;
	}
}
.link-jump {
	float: right;
}
</style>
